var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.697,
    height: 16.358,
    viewBox: "0 0 26.697 16.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(-128.672 -391.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M226.31,399.384a8.181,8.181,0,1,1,8.1,8.2A8.182,8.182,0,0,1,226.31,399.384Zm8.571,4.122c-.17-.5.2-.5.491-.635a3.309,3.309,0,0,0,1.13-.724,1.965,1.965,0,0,0-.728-3c-.5-.288-1.064-.481-1.545-.8a.989.989,0,0,1-.425-.739.831.831,0,0,1,.614-.517,11.878,11.878,0,0,1,1.609.108c.172.011.428.035.506-.061a.878.878,0,0,0-.483-1.258,2.794,2.794,0,0,0-.626-.085c-.346,0-.643-.036-.6-.492h-.673l-.1.495c-.221.07-.407.122-.589.189a1.9,1.9,0,0,0-1.372,1.589,1.845,1.845,0,0,0,.929,1.93c.555.336,1.182.554,1.728.9.228.146.5.535.444.736a.932.932,0,0,1-.687.569,13.773,13.773,0,0,1-1.844-.258c-.164-.023-.42-.051-.492.038a.958.958,0,0,0,.456,1.337c.459.112.931.168,1.433.255l.109.417Zm-.722-10.074a6.015,6.015,0,0,1,6.172,5.743A5.811,5.811,0,0,1,239,403.142a5.973,5.973,0,0,1-4.834,2.211v.9a6.7,6.7,0,0,0,6.073-3.331,6.5,6.5,0,0,0-.239-7.419,6.682,6.682,0,0,0-5.84-2.954Z",
    transform: "translate(-87.302 -0.041)",
    fill: "#f10078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M137.448,461.623c-.158.01-.312.028-.466.028q-3.564,0-7.127,0a1.773,1.773,0,0,1-.622-.081.736.736,0,0,1-.538-.861,1.979,1.979,0,0,1,.567-.8c.1-.1.335-.079.508-.079q3.669-.008,7.338,0c.1,0,.206.018.34.03Z",
    transform: "translate(0 -61.375)",
    fill: "#f10078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M170.8,496.119c-1.777,0-3.469.01-5.162-.006a.89.89,0,0,1-.9-.912.88.88,0,0,1,.92-.889c1.376-.013,2.752-.01,4.127,0a.476.476,0,0,1,.369.181C170.38,495.005,170.57,495.531,170.8,496.119Z",
    transform: "translate(-32.245 -92.208)",
    fill: "#f10078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M171.566,425.49c-.231.59-.416,1.1-.638,1.594a.464.464,0,0,1-.354.2q-2.036.021-4.072,0a.9.9,0,0,1-.066-1.793C168.125,425.478,169.815,425.49,171.566,425.49Z",
    transform: "translate(-33.012 -30.674)",
    fill: "#f10078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M213.447,530.341c-1.319,0-2.609.03-3.9-.016-.449-.016-.686-.4-.7-.854a.871.871,0,0,1,.8-.9c.576-.045,1.158-.022,1.737-.014a.463.463,0,0,1,.275.123C212.242,529.218,212.824,529.763,213.447,530.341Z",
    transform: "translate(-71.686 -122.824)",
    fill: "#f10078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M213.827,391.183c-.653.606-1.235,1.157-1.833,1.69a.639.639,0,0,1-.382.119c-.457.014-.915.017-1.373,0a.925.925,0,0,1-1-.933.9.9,0,0,1,.982-.878C211.4,391.176,212.581,391.183,213.827,391.183Z",
    transform: "translate(-72.042 0)",
    fill: "#f10078"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletsicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/wallets.icon.f3ecf58aaf206847f52bf784e8576bf8.svg";
export { ForwardRef as ReactComponent };